import {useEffect} from 'react'
import useControlledTableProperty from '../Utils/useControlledTableProperty'

const useColumnVisibility = ({defaultColumnVisibility, onColumnVisibilityChange, table}) => {
  const [columnVisibility, setColumnVisibility] = useControlledTableProperty({
    initialValue: {},
    controlledValue: defaultColumnVisibility,
    name: 'columnVisibility',
    onChangeFn: onColumnVisibilityChange
  })

  useEffect(() => {
    table?.setColumnVisibility(defaultColumnVisibility || {})
  }, [defaultColumnVisibility, table?.setColumnVisibility])

  useEffect(() => {
    // set the visibility of columns based on what the column definitions tell us
    table?.getAllLeafColumns().forEach(column => {
      const v = columns.some(col => { return col.id === column.id && col.show !== false })
      column.toggleVisibility(v)
    })
  }, [table?.getAllLeafColumns])

  return {
    columnVisibility,
    setColumnVisibility
  }
}

export default useColumnVisibility